import { inject, Injectable } from '@angular/core';
import { ApiServices, SharedApiExecutorService } from '@ddv/http';
import { Observable, interval, map, switchMap } from 'rxjs';

@Injectable()
export class VersionsService {
    private readonly monitorApiExecutor = inject<SharedApiExecutorService>(ApiServices.monitorApi);

    getVersions(): Observable<Record<string, string>> {
        return this.monitorApiExecutor.invokeServiceWithParams<{ build: { version: string } }>('api/monitor').pipe(map((api) => {
            return {
                'DDV UI version': api?.build?.version ?? '',
            };
        }));
    }

    pollUiVersion(pollIntervalMs: number): Observable<string> {
        return interval(pollIntervalMs).pipe(
            switchMap(() =>
                this.monitorApiExecutor.invokeServiceWithParams<{ build: { version: string } }>('api/monitor'),
            ),
            map((response) => response?.build?.version ?? ''),
        );
    }
}
